<template>
  <!--
      	作者：kmdshop
      	时间：2022-12-22
      	描述：插件中心-销售自定义列表-列表
      -->
  <div>
    <!-- <div class="common-level-rail">
      <el-button style="float: right;"
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="addArticle"
        >添加文章</el-button>

    </div> -->
    
 <!-- type text  文字  select  下拉选 -->
  <el-form size="small" :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline">
    
      <span v-for="(item,index) in searchFrom" :key="index">
        <el-form-item v-if="item.type == 'select'"  :label="item.label">
          <el-select id="searchType" v-model="item.val" class="searchType">
              <el-option v-for="(itemA,indexA) in item.option" :key="indexA" 
              :value="itemA.year"
              :label="itemA.year"></el-option>      
          </el-select>
        </el-form-item> 
        <el-form-item v-if="item.type == 'text'"  :label="item.label">
          <el-input size="small"  :placeholder="item.placeholder" v-model="item.val">
          </el-input>
        </el-form-item> 
  
      </span>
      
      <el-form-item v-if="searchFrom.length > 0">
        <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        <!-- <el-form-item><el-button size="small" type="success" @click="onExport"  v-auth="'/plus/salestarget/export'">导出</el-button></el-form-item> -->
      </el-form-item>
    </el-form>


    <div class="operaction" style="display: flex;">
      <div class="common-level-rail" style="margin-right:20px;"><el-button size="small"  @click="submitBatch">批量删除</el-button></div>
    </div>

    <div class="table-wrap">
      <el-table :data="tableData" @sort-change="sortChange"  sortable   
         style="width: 100%" v-loading="loading"
        
          
          @selection-change="selectedChange"
          @select="handleSelect"
          @select-cancel="handleCancel"
          @select-all-cancel="handleCancelSelectAll"
          @select-all="handleSelectAll"
          
          >
        <el-table-column type="selection"  width="45"></el-table-column>
        <el-table-column prop="sales_target_id" label="ID" width="60" ></el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="60" ></el-table-column>
        <el-table-column prop="mobile" label="用户手机号"  ></el-table-column>
        <el-table-column prop="nickName" label="用户昵称" ></el-table-column>
      
        <el-table-column prop="new_num" sortable label="新客户数量" ></el-table-column>
        <el-table-column prop="new_per_price" sortable label="新客户均价" ></el-table-column>
        <el-table-column prop="new" sortable label="新客户销售目标" ></el-table-column>
        <el-table-column prop="renew_num" sortable label="续老客户数量" ></el-table-column>
        <el-table-column prop="renew_per_price" sortable label="老客户均价" ></el-table-column>
        <el-table-column prop="old" sortable label="老客户续费目标" ></el-table-column>
        <el-table-column prop="total" sortable label="总额"  ></el-table-column>
        <el-table-column prop="introduce" label="说明"  ></el-table-column>
        <el-table-column prop="" label="历史记录"  >
          <template slot-scope="scope">
                  <a :href="'#/plus/salestarget/detail?user_id='+scope.row.user_id">{{ scope.row.is_history }}</a>
          </template>
        </el-table-column>
        <el-table-column prop="year" label="年度"  ></el-table-column>
        <el-table-column prop="create_time" label="添加时间"   ></el-table-column>
        <el-table-column  prop="update_time" label="更新时间"    ></el-table-column>
        <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="delClick(scope.row)" type="text" size="small" v-auth="'/plus/salestarget/delete'">删除</el-button>
            </template>
          </el-table-column>
      </el-table>

   
      <!--分页-->
      <div class="pagination">
        <el-pagination
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import Salestarget from "@/api/salestarget.js";
import _ from 'lodash';
export default {
  data() {
    return {
      searchFrom:[],
      /*表单数据*/
      tableData: [],
      loading: true,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      order:"",
      sortStr:"",
      selectedData: [],
		  selected: [],
      
    };
  },
  created() {
    this.loading = true;
    this.getTableList();
  },
  methods: {
    onExport: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/plus.salestarget/export?' + qs.stringify(this.searchForm);
    },


    sortChange(column) {
      this.order = "";
       if (column) {
        this.tableData = [];
        if(column.prop == "total" && column.order === 'ascending' ){
          this.order = "st.total DESC"
        }else if(column.prop == "total" && column.order === 'descending' ){
          this.order = "st.total ASC"
        }
        if(column.prop == "new_num" && column.order === 'ascending' ){
          this.order = "st.new_num DESC"
        }else if(column.prop == "new_num" && column.order === 'descending' ){
          this.order = "st.new_num ASC"
        }

        if(column.prop == "new_per_price" && column.order === 'ascending' ){
          this.order = "st.new_per_price DESC"
        }else if(column.prop == "new_per_price" && column.order === 'descending' ){
          this.order = "st.new_per_price ASC"
        }

        if(column.prop == "renew_num" && column.order === 'ascending' ){
          this.order = "st.renew_num DESC"
        }else if(column.prop == "renew_num" && column.order === 'descending' ){
          this.order = "st.renew_num ASC"
        }

        if(column.prop == "renew_per_price" && column.order === 'ascending' ){
          this.order = "st.renew_per_price DESC"
        }else if(column.prop == "renew_per_price" && column.order === 'descending' ){
          this.order = "st.renew_per_price ASC"
        }
        if(column.prop == "new" && column.order === 'ascending' ){
          this.order = "st.new_num * st.new_per_price DESC"
        }else if(column.prop == "new" && column.order === 'descending' ){
          this.order = "st.new_num * st.new_per_price ASC"
        }

        if(column.prop == "old" && column.order === 'ascending' ){
          this.order = "st.renew_num * st.renew_per_price DESC"
        }else if(column.prop == "renew_per_price" && column.order === 'descending' ){
          this.order = "st.renew_num * st.renew_per_price ASC"
        }
        if( this.searchFrom[0].type == "order"){
          this.searchFrom[0].val = this.order
        }
        
        this.getTableList();
       }
    },
    /*获取销售目标列表*/
    getTableList() {
      let self = this;
      let Params = {};
      Params.page = self.curPage;
      Params.searchFrom = JSON.stringify(self.searchFrom)

      //
      Salestarget.getCurrentList(Params, true)
        .then((data) => {
          console.log(data.data.list)
          self.loading = false;
          self.tableData = data.data.list;
          self.totalDataNumber = data.data.totalDataNumber;
          self.pageSize=data.data.pageSize;
          self.curPage = data.data.curPage
          self.searchFrom = data.data.search

        })
        .catch((error) => {
          self.loading = false;
        });
    },
 
    


 


    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.getData();
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },
  /*删除*/
  delClick: function(row) {
      let self = this;
      self
        .$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          Salestarget.del({
            sales_target_id: row.sales_target_id
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getTableList();
          });
        });
    },

    // 批量删除
    submitBatch:function(row){
     var self = this;
      if(self.selectedData.length <= 0){
        self.$message({
              message: '请选择要删除的记录',
              type: 'error'
            });
      }else{
        var del_str = "";
        self.selectedData.forEach(function(res){
            del_str+=res.sales_target_id+",";
        })
        del_str = del_str.substring(0,del_str.length -1)
        self.$confirm('删除后不可恢复，确认删除该记录吗?', '提示', {
          type: 'warning'
        })
        .then(() => {
          Salestarget.del({
            sales_target_id: del_str
          }).then(data => {
            self.$message({
              message: '删除成功',
              type: 'success'
            });
            self.getTableList();
          });
        });
      }
    },
  
    handleClick(tab, event) {},

   

    // 批量修改状态
    editStatus(){

    },

    // 表格选中数据
    selectedChange(selection) {
      console.log(selection)
                this.selectedData = selection;
            },
            // 取消选中
            handleCancel(selection, row) {
                //从已选项中去除取消项
                _.remove(this.selected, n => {
                    return n.sales_target_id === row.sales_target_id;
                });
            },
            // 选中
            handleSelect(selection, row) {
                //添加到已选项
                this.selected.push(row);
            },
            // 全选
            handleSelectAll(selection) {
                //数组合并，有可能用户先选择了某几项，已经被我们push进去，因此数组合并需要去重一下
                this.selected = _.uniqBy(this.selected.concat(selection), "sales_target_id");
            },
            // 取消全选
            handleCancelSelectAll(selection) {
                //从已选项中移除当页数据
                this.selected = _.differenceBy(this.selected, this.tableData, "sales_target_id");
            },
            //把源数据加上_checked字段，遍历已选项数据，更新选中状态
            updateChecked() {
                for (var i = 0; i < this.tableData.length; i++) {
                    this.tableData[i]._checked = false;
                    for (var j = 0; j < this.selected.length; j++) {
                        if (this.selected[j].sales_target_id === this.tableData[i].sales_target_id) {
                            this.tableData[i]._checked = true;
                        }
                    }
                }
            },
  },
};
</script>

<style >
 /* 设置点击行的效果 */
 .el-table .rowStyle {
        background: #f0f9eb !important;
    }
</style>



// WEBPACK FOOTER //
// src/views/plus/salestarget/target/Index.vue